import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { DataCacheService } from "@app/services/caching/data-cache.service";
import { Observable, Subject } from "rxjs";
import { tap } from "rxjs/operators";
import { EngineerJobItemStatus } from "../foundation.enums";
import { IEngineerJobItem, IProcessResult } from "../foundation.interfaces";
interface IJobItemStatusStyle {
    icon?: string;
    iconColor?: string;
}

export interface IEngineerJobItemQueryOptions {
    jobItemId?: number
    JobId?: number
  }


@Injectable({
    providedIn: 'root'
})
export class EngineerJobItemService {
    private jobItemsCacheName: string = "engineerJobItemsCache";

    constructor(
        private readonly http: HttpClient,
        private readonly dataCacheService: DataCacheService
    ) { }

    getAllEngineerJobItems(invalidateCache = false): Observable<IEngineerJobItem[]> {
        return this.dataCacheService.getOrRequest(this.jobItemsCacheName, () => this.getEngineerJobItemsFromDb(), { invalidateCache })
    }

    getEngineerJobItemsFromDb(): Observable<IEngineerJobItem[]> {
        return this.http.get<IEngineerJobItem[]>(`/api/foundation/engineerJobItems`);
    }

    getEngineerJobItems(queryOptions: IEngineerJobItemQueryOptions = {}): Observable<IEngineerJobItem[]> {
        return this.http.get<IEngineerJobItem[]>(`/api/foundation/engineerJobItems`, { params: queryOptions as HttpParams });
    }

    createUpdateEngineerJobItem(engineerJobItem: IEngineerJobItem): Observable<IEngineerJobItem> {
        return this.http.post<IEngineerJobItem>(`/api/foundation/engineerJobItems/`, engineerJobItem).pipe(
            tap(jobItem => {
                this.dataCacheService.addOrUpdateItem(jobItem, this.jobItemsCacheName);
            })
        );
    }

    completeEngineerJobItem(jobItemId: number): Observable<IProcessResult> {
        return this.http.post<IProcessResult>(`/api/foundation/engineerJobItems/complete`, Number(jobItemId) ); 
    }

    closeEngineerJobItem(jobItem: IEngineerJobItem): Observable<any> {
        jobItem.Status = EngineerJobItemStatus.Cancelled;
        return this.createUpdateEngineerJobItem(jobItem);
    }

    calculateJobCompletion(jobItems: IEngineerJobItem[]): { completedJobItems: number, totalJobItems: number } {
        if (!jobItems.length) {
            return { completedJobItems: 0, totalJobItems: 0 };
        }

        const totalJobItems = jobItems.filter(item => item.Status !== EngineerJobItemStatus.Cancelled).length;
        const completedJobItems = jobItems.filter(item => item.Status === EngineerJobItemStatus.Complete).length;

        return { completedJobItems, totalJobItems };
    }

}
